import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import API_URL from '../constants/environment';
import { useContext } from 'react';
import SessionContext from '../contexts/SessionContext';

interface SkipQuotingInput {
    orderId: string;
    allowAutoOrder: boolean;
    potentialTotal: boolean;
    quotesOnly: boolean;
    preOrder: boolean;
    oemEndorsement: boolean;
    resubmit?: boolean;
}

const skipQuoting = async (payload: SkipQuotingInput, sessionId: string | null) => {
    return axios.post(`${API_URL}/order/skip-quotes`,
        payload,
        {
            headers: {
                Authorization: sessionId
            }
        }
    );
};

export const useSkipQuoting = () => {
    const sessionContext = useContext(SessionContext);

    return useMutation({
        mutationFn: (payload: SkipQuotingInput) => skipQuoting(payload, sessionContext?.sessionId ?? null),
    });
};

